import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
// import { RootState } from '../react-redux/rootReducer';
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
